import React, { useContext, useEffect, useState } from "react";
import { green } from "@material-ui/core/colors";
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
} from "@material-ui/core";
import {
  SchoolApi,
  DashboardEducationDto,
  EducationDto,
} from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";
import { SchoolContext } from "../../contexts/SchoolContext";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import CardContentEducation from "./CardContentEducation";

interface IProps {
  education: EducationDto;
}
export default function CardEducation({ education }: IProps) {
  const [schoolApi] = useState<SchoolApi>(new SchoolApi(getApiUrl()));
  const history = useHistory();
  const [dashboard, setDashboard] = useState<DashboardEducationDto | null>(
    null
  );
  const { accademicYear } = useContext(SchoolContext);

  useEffect(() => {
    if (accademicYear != null && accademicYear.accademicYearId != null && education.educationId != null)
      schoolApi
        .dashboardEducation(accademicYear.accademicYearId, education.educationId)
        .then((res) => {
          setDashboard(res);
        });
  }, [schoolApi, accademicYear, education]);

  return (
    <Card>
      <CardActionArea
        onClick={() => history.push("/education/" + education.educationId)}
      >
        <CardHeader
          title={education.name}
          avatar={
            <Avatar style={{ backgroundColor: green[200] }}>
              <FontAwesomeIcon icon={faGraduationCap} />
            </Avatar>
          }
        />
      </CardActionArea>
      <CardContent>
        <CardContentEducation dashboard={dashboard} />
      </CardContent>
    </Card>
  );
}
